import { Fetch } from '../utils'
import { ApiEndpoints } from '../constants'
import { UserCommunicationProfile } from '..'
import type { Device, GlobalErrorHandler, NotificationProfile } from '..'

export class SettingsApi {
  fetchInstance: Fetch

  constructor(endpoint: string, token: string, onError?: GlobalErrorHandler) {
    this.fetchInstance = new Fetch(endpoint, token, undefined, onError)
  }

  deleteDevice = async (guid: string) => {
    return this.fetchInstance.delete(`${ApiEndpoints.DEVICES}/${guid}`).then((data) => data)
  }

  generateDeviceToken = async () => {
    return this.fetchInstance
      .get(`${ApiEndpoints.USER}/mobile_token`)
      .then((data) => data.mobile_token)
  }

  getDevices = async () => {
    return this.fetchInstance
      .get(ApiEndpoints.DEVICES)
      .then((data) => data.map((item: { device: Device }) => item.device))
  }

  getNotificationProfiles = async () => {
    return this.fetchInstance
      .get(ApiEndpoints.NOTIFICATION_PROFILES)
      .then((data) => data.notification_profiles)
  }

  // verifications endpoints respond with HTTP status codes; they error otherwise
  sendEmailVerification = async () => {
    return this.fetchInstance.post(ApiEndpoints.EMAIL_VERIFICATIONS)
  }

  sendPhoneVerification = async () => {
    return this.fetchInstance.post(ApiEndpoints.PHONE_VERIFICATIONS + '/deliver')
  }

  verifyPhoneToken = async (sms_verification_token: string) => {
    return this.fetchInstance
      .post(ApiEndpoints.PHONE_VERIFICATIONS + '/verify', { sms_verification_token })
      .then((res) => ({ verified: res.verified }))
  }

  updateDevice = async (device: Device) => {
    return this.fetchInstance
      .put(`${ApiEndpoints.DEVICES}/${device.guid}`, device)
      .then((data) => data.device)
  }

  updateNotificationProfile = async (notificationProfile: NotificationProfile) => {
    return this.fetchInstance
      .put(`${ApiEndpoints.NOTIFICATION_PROFILES}/${notificationProfile.guid}`, notificationProfile)
      .then((data) => data.notification_profile)
  }

  updateUserCommunicationProfile = async (userCommunicationProfile: UserCommunicationProfile) => {
    return this.fetchInstance
      .put(ApiEndpoints.USER_COMMUNICATION_PROFILE, userCommunicationProfile)
      .then((data) => data.user_communication_profile)
  }

  updatePassword = async (params: { new_password: string; new_password_again: string }) => {
    return this.fetchInstance.put(ApiEndpoints.CHANGE_PASSWORD, params)
  }

  getInsightsNotificationProfiles = async () => {
    return this.fetchInstance
      .get(`${ApiEndpoints.NOTIFICATION_PROFILES}/${ApiEndpoints.INSIGHTS_NOTIFICATION_PROFILES}`)
      .then((data) => data)
  }
}
